import { render, staticRenderFns } from "./ClientesNuevo.vue?vue&type=template&id=0e7fb416&scoped=true&"
import script from "./ClientesNuevo.vue?vue&type=script&lang=js&"
export * from "./ClientesNuevo.vue?vue&type=script&lang=js&"
import style0 from "./ClientesNuevo.vue?vue&type=style&index=0&id=0e7fb416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7fb416",
  null
  
)

export default component.exports